<template>
  <nav class="breadcrumb">
    <ul>
      <li v-for="navLink in cNavLinks" :key="navLink.link!!">
        <NuxtLink v-if="navLink.link" :to="navLink.link">{{ navLink.label }}</NuxtLink>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import type { BreadcrumbResponseModel } from '@api';

interface Breadcrumb {
  navLinks: BreadcrumbResponseModel[];
}

const props = defineProps<Breadcrumb>();

const cNavLinks = computed(() => props.navLinks.filter((link) => link.link));
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: px(20);
  font-size: 0.9rem;
  height: px(24);
  margin-bottom: px(4);

  ul {
    display: flex;
    grid-column: 1 / 12;
    padding: 0 px(20);

    li {
      padding-right: px(16);

      &::after {
        content: '>';
        display: inline-block;
        padding-left: px(16);
      }

      &:last-child {
        padding-right: 0;

        &::after {
          display: none;
        }
      }

      a {
        position: relative;
        text-decoration: underline;
      }
    }
  }

  @include media-breakpoint-up(lg) {
    margin-bottom: px(24);
    gap: px(30);

    ul {
      grid-column: 3 / 12;
    }
  }
}
</style>
